import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-disturbute_horizontal_spacing",
  "use": "icon-disturbute_horizontal_spacing-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-disturbute_horizontal_spacing\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M10,8h4v8H10ZM6,18H7V6H6Zm11,0h1V6H17Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol